<template>
    <ul class="list-group video-manual-list">
        <li
            class="video-manual-item"
            v-for="(video, videoIndex) in videoArray"
            :key="videoIndex"
            @click="showVideoModal(video)">
            <div class="icon">
                <i class="video-file-icon btn-video-file"></i>
            </div>
            <span class="title">
                {{ video.title }}
            </span>

            <b-modal
                :id="`video-tutorial-${video.id}`"
                :ref="`video-tutorial-${video.id}`"
                :title="`Video ${video.title}`"
                :ok-title="$t('common.close')"
                ok-variant="primary"
                centered
                size="lg"
                ok-only
                body-class="video-tutorial-modal-body px-0 pb-0"
                modal-class="apprentice-default-modal clean-modal-no-scroll">
                <div class="text-center">
                    <design-2021-apprentice-video-player-component :options="getVideoOptions(video)">
                    </design-2021-apprentice-video-player-component>
                </div>
            </b-modal>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'design-2021-video-tutorial-component',
    data() {
        return {
            videoArray: [
                {
                    id: 0,
                    title: this.$t('help.video_manual.add_assessment_to_the_culture_card_file'),
                    url: 'https://youtu.be/QsGlWGrg25o',
                    thumbnail: 'video-tutorial-thumbnail-1.png',
                },
                {
                    id: 1,
                    title: this.$t('help.video_manual.creating_assignments_in_the_culture_card_file'),
                    url: 'https://youtu.be/fpXexhqabQI',
                    thumbnail: 'video-tutorial-thumbnail-2.png',
                },
                {
                    id: 2,
                    title: this.$t('help.video_manual.use_of_progress_filters_and_checking_the_culture_card_file'),
                    url: 'https://youtu.be/6z9epWgAJXo',
                    thumbnail: 'video-tutorial-thumbnail-3.png',
                },
                {
                    id: 3,
                    title: this.$t('help.video_manual.using_tools_and_editing_the_name_in_the_culture_card_file'),
                    url: 'https://youtu.be/QsGlWGrg25o',
                    thumbnail: 'video-tutorial-thumbnail-4.png',
                },
            ],
            options: {
                autoplay: true,
            },
        };
    },
    methods: {
        showVideoModal(video) {
            this.$bvModal.show(`video-tutorial-${video.id}`);
        },

        getVideoOptions(video) {
            return {
                responsive: true,
                autoplay: true,
                controls: true,
                sources: [
                    {
                        src: video.url,
                        type: 'video/youtube',
                    },
                ],
            };
        },
    },
};
</script>

<style scoped lang="scss"></style>
